import { render, staticRenderFns } from "./EditIcon2.vue?vue&type=template&id=42ad0bce"
import script from "./EditIcon2.vue?vue&type=script&lang=js"
export * from "./EditIcon2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports